// Amcharts3
import '@/modules/amcharts'
import { isEmpty } from 'lodash-es'

export default {
  props: {
    id: {
      type: String,
      required: true
    },

    modem: {
      type: Object,
      required: true
    }
  },

  watch: {
    modem () {
      this.$nextTick(this.createChart)
    }
  },

  created () {
    this.$nextTick(this.createChart)
  },

  methods: {
    createChart () {
      if (isEmpty(this.modem)) return

      window.AmCharts.makeChart(this.id, {
        type: 'gantt',
        rotate: true,
        theme: 'none',
        autoMarginOffset: 25,
        marginRight: 30,
        addClassNames: true,
        titles: [{
          text: this.modemName || '',
          size: 12
        }],
        graph: {
          lineColor: '#808080',
          lineAlpha: 1,
          fillAlphas: 0.7,
          balloonText: '<strong>[[t_text]]</strong><br>[[text_balloon]]',
          borderColor: 'black',
          borderAlpha: 1
        },
        valueAxis: {
          minimum: this.minFreq,
          maximum: this.maxFreq,
          unit: ' MHz'
        },
        categoryField: 'empty_string',
        segmentsField: 'RF_config',
        startField: 'freqband_low',
        endField: 'freqband_high',
        colorField: 'color',
        columnWidthField: 'width',
        dataProvider: this.dataProvider,
        listeners: [{
          event: 'drawn',
          method: (evt) => {
            this.setChartRadioPathThreshold(evt.chart)
          }
        }]
      })
    },

    /**
     * Add a radio path threshold on a chart.
     * Chart must declare option 'addClassNames' to true.
     * This function should be called in the 'drawn' event listener callback
     * @param chart     the chart object
     * @param threshold frequency interval attenuation threshold (relative value), defaults to 8
     */
    setChartRadioPathThreshold (chart, threshold) {
      if (chart === undefined) return
      if (chart.div === undefined) return
      const chartId = chart.div.id
      threshold = arguments[2] || 8

      const bottomAxis = document.querySelectorAll('#' + chartId + ' .amcharts-value-axis > path')[0]
      const bottomAxisY = parseInt(bottomAxis.getAttribute('transform').match(/translate\(\d+[,\s]?(\d+)\)/)[1])

      chart.graphs.forEach((element) => {
        const graphId = element.id
        const svgPaths = document.querySelectorAll('#' + chartId + ' .amcharts-graph-' + graphId + ' > path')
        if (svgPaths.length > 0) {
          const svgPath = svgPaths[0]
          // 1. translate all path to the same bottom axis
          const g = svgPath.parentNode
          const py = parseInt(g.parentNode.parentNode.getAttribute('transform').match(/translate\(\d+[,\s](\d+)\)/)[1]) // Parent y translation
          const y = parseInt(g.getAttribute('transform').match(/translate\(\d+[,\s](\d+)\)/)[1]) // Element y translation
          const bb = g.getBoundingClientRect() // Element size
          const delta = bottomAxisY - py - y - bb.height
          const _y = y + delta
          g.setAttribute('transform', g.getAttribute('transform').replace(/[,\s]\d+/, ' ' + _y))

          // 2. recompute path shape using threshold value
          let d = svgPath.getAttribute('d')
          // d='M8.5,0.5 L0.5,114.5 L30.5,114.5 L22.5,0.5 L8.5,0.5 Z';
          d = d.replace(/^M\s?(\d+\.?\d*)[,\s].*L\s?(\d+\.?\d*)[,\s]\d+\.?\d*\sL\s?(\d+\.?\d*)[,\s]\d+\.?\d*\sZ$/gi, (match, p1, p2, p3) => {
            const _threshold = Math.min(threshold, Math.round((p2 - p1) / 2)) // avoid top point switching
            const _p1 = parseFloat(p1) + parseFloat(_threshold)
            const _p2 = parseFloat(p2) - parseFloat(_threshold)
            const _p3 = parseFloat(p3) + parseFloat(_threshold)
            return match
              .replace(/^M\s?(\d+\.?\d*)/gi, 'M ' + _p1)
              .replace(/L\s?\d+\.?\d*([,\s]\d+\.?\d*\sL\s?\d+\.?\d*[,\s]\d+\.?\d*\sZ)$/gi, 'L ' + _p2 + '$1')
              .replace(/L\s?\d+\.?\d*([,\s]\d+\.?\d*\sZ)$/gi, 'L ' + _p3 + '$1')
          })
          svgPath.setAttribute('d', d)
        }
      })
    }
  }
}
